import React from "react";
import { Box, Text } from "@chakra-ui/react";

/**
 * RouteDetails Component
 * Shows Point A (before visit) and Point C (after visit) information
 */
export default function RouteDetails({ pointA, pointC }) {
  if (!pointA && !pointC) return null;

  return (
    <Box flex="1" minW={0} w="full">
      <Text fontSize="sm" color="gray.500" mb={2} fontWeight="medium">
        Route Details
      </Text>

      {/* Point A - Before */}
      {pointA && (
        <Box mb={2} p={3} bg="blue.50" borderRadius="md" borderLeft="3px solid" borderColor="blue.400">
          <Text fontSize="xs" color="blue.600" fontWeight="semibold" mb={1}>
            Before (Point A)
          </Text>
          <Text fontSize="sm" fontWeight="medium" color="gray.800">
            {pointA.title}
          </Text>
          <Text fontSize="xs" color="gray.600" mt={1}>
            {new Date(pointA.start_at).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })}
            {' - '}
            {new Date(pointA.end_at).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })}
          </Text>
          {pointA.address && (
            <Text fontSize="xs" color="gray.500" mt={1}>
              {pointA.address}
            </Text>
          )}
        </Box>
      )}

      {/* Point C - After */}
      {pointC && (
        <Box p={3} bg="green.50" borderRadius="md" borderLeft="3px solid" borderColor="green.400">
          <Text fontSize="xs" color="green.600" fontWeight="semibold" mb={1}>
            After (Point C)
          </Text>
          <Text fontSize="sm" fontWeight="medium" color="gray.800">
            {pointC.title}
          </Text>
          <Text fontSize="xs" color="gray.600" mt={1}>
            {new Date(pointC.start_at).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })}
            {' - '}
            {new Date(pointC.end_at).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })}
          </Text>
          {pointC.address && (
            <Text fontSize="xs" color="gray.500" mt={1}>
              {pointC.address}
            </Text>
          )}
        </Box>
      )}
    </Box>
  );
}
